import type Stripe from 'stripe';

/** Resolves a Stripe payment method id whether the API returned an id string or an expanded object. */
export function stripePaymentMethodId(value: string | Stripe.PaymentMethod | null | undefined): string | null {
  if (value == null) return null;
  if (typeof value === 'string') return value;
  if (typeof value === 'object' && 'id' in value && typeof value.id === 'string') {
    return value.id;
  }
  return null;
}
